'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishMessage = publishMessage;

var _gdprConsentToProcessEnabled = require('conversations-schema/operators/widget-data/gdprConsentToProcessEnabled');

var _gdprExplicitConsentRequired = require('conversations-schema/operators/widget-data/gdprExplicitConsentRequired');

var _WidgetDataModel = require('conversations-schema/models/WidgetDataModel');

var _getHasGivenConsentToProcess = require('../../gdpr/selectors/getHasGivenConsentToProcess');

var _visitorConsentsToProcess = require('../../gdpr/actions/visitorConsentsToProcess');

var _getWidgetData = require('../../selectors/widgetDataSelectors/getWidgetData');

var _publishMessageWithAbly = require('../../pubsub/actions/publishMessageWithAbly');

function publishMessage(_ref) {
  var text = _ref.text,
      richText = _ref.richText,
      quickReply = _ref.quickReply,
      url = _ref.url,
      attachments = _ref.attachments;

  return function (dispatch, getState) {
    var widgetData = (0, _getWidgetData.getWidgetData)(getState());

    if ((0, _gdprConsentToProcessEnabled.gdprConsentToProcessEnabled)(widgetData) && !(0, _getHasGivenConsentToProcess.getHasGivenConsentToProcess)(getState()) && !(0, _gdprExplicitConsentRequired.gdprExplicitConsentRequired)(widgetData)) {
      dispatch((0, _visitorConsentsToProcess.consentToProcess)({
        sessionId: (0, _WidgetDataModel.getSessionId)(widgetData)
      }));
    }

    dispatch((0, _publishMessageWithAbly.publishMessageWithAbly)({ text: text, richText: richText, quickReply: quickReply, url: url, attachments: attachments }));
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/actions/PublishActions/publishMessage.js
// module id = 642
// module chunks = 2 3